import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import JsonLd, { getBaseUrl } from './components/JsonLd';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import WhyUs from './pages/WhyUs';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import '@/App.css';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const baseUrl = getBaseUrl();
  const localBusiness = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${baseUrl}#localbusiness`,
    name: 'MB „WSK Logistikos paslaugos“',
    url: baseUrl,
    telephone: '+37065017855',
    email: 'info@wsklogistika.lt',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ateities pl. 28 c',
      postalCode: 'LT-52181',
      addressLocality: 'Kaunas',
      addressCountry: 'LT'
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday'
        ],
        opens: '09:00',
        closes: '17:00'
      }
    ],
    areaServed: [
      { '@type': 'AdministrativeArea', name: 'Kaunas' },
      { '@type': 'Country', name: 'Lithuania' }
    ],
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        telephone: '+37065017855',
        email: 'info@wsklogistika.lt',
        availableLanguage: ['lt']
      }
    ]
  };

  return (
    <div className="App">
      <BrowserRouter>
        <JsonLd id="localbusiness" data={localBusiness} />
        <ScrollToTop />
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apie-mus" element={<About />} />
            <Route path="/paslaugos" element={<Services />} />
            <Route path="/kodel-mes" element={<WhyUs />} />
            <Route path="/kontaktai" element={<Contact />} />
            <Route path="/privatumo-politika" element={<PrivacyPolicy />} />
            <Route path="/slapuku-politika" element={<CookiePolicy />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
